var sentryDsn = "https://9baab3f18fe14fbb8c167af315d71514@o354215.ingest.sentry.io/6350462";
var retryPaymentBaseUrl = "/payment/api/retry-payment-k8s/v1";
var defaultConfig = {
	sentryDsn: sentryDsn,
	retryPaymentBaseUrl: retryPaymentBaseUrl
};

export { defaultConfig as default, retryPaymentBaseUrl, sentryDsn };
//# sourceMappingURL=default.json.js.map
